import { render } from "./ExamList.vue?vue&type=template&id=460133e2&scoped=true"
import script from "./ExamList.vue?vue&type=script&lang=js"
export * from "./ExamList.vue?vue&type=script&lang=js"

import "./ExamList.vue?vue&type=style&index=0&id=460133e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460133e2"]])

export default __exports__